import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { PendingApprovalsPage } from "@/screens/Dashboard/components/PendingApprovalsPage"
import { pendingApprovalsSearchSchema } from "@/screens/Dashboard/schemas"

export const Route = createFileRoute("/app/dashboard/_layout/pending-approvals/_layout")({
  validateSearch: zodValidator(pendingApprovalsSearchSchema),
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.DASHBOARD_PENDING_APPROVALS]}>
      <PendingApprovalsPage />
    </PermissionContentWrapper>
  ),
})
